import { Box, InputAdornment, Modal, TextField, Tooltip } from "@mui/material";
import React, { useState, useEffect, useMemo } from "react";
import CancelPresentationIconButton from "../../common/components/Buttons/CancelPresentationIconButton";
import RadioField from "../../common/components/FormFields/RadioField";
import { useForm } from "react-hook-form";
import DatePickerField from "../../common/components/FormFields/DatePickerFieldNew";
import SearchIcon from "@mui/icons-material/Search";
import LoadingSpinner from "../../common/components/loadingspinner/loadingSpinner";
import CommonDynamicTablePaginationNew from "../../common/components/CommonTable/CommonDynamicTablePaginationNew";
import CommonButton from "../../common/components/Buttons/CommonButton";
import { getSalesPrevReturnList } from "./Services";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { errorAlert } from "../../common/components/Toasts/CustomToasts";

const patientTypeObj = [
  { id: 3, value: 3, label: "All" },
  { id: 0, value: 0, label: "OPD" },
  { id: 1, value: 1, label: "IPD" },
  { id: 2, value: 2, label: "Counter" },
];
const PreviousReturnListModal = (props) => {
  const loggedUser = JSON.parse(localStorage.getItem("userInfo"));

  const {
    openPrevReturnListModal,
    setOpenPrevReturnListModal,
    menuId,
    privilege,
    userActions,
    openPrintWindow,
  } = props;

  const [previousReturnList, setPreviousReturnList] = useState([]);
  const [showSpinner, setShowSpinner] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(null);

  const defaultValues = {
    patientType: 3,
    fromDate: new Date(),
    toDate: new Date(),
    mrNo: "",
    saleReturnNo: "",
  };

  const { control, watch, setValue, register } = useForm({
    defaultValues: defaultValues,
  });

  let getPatientType = Number(watch("patientType"));
  let getFromDate = watch("fromDate");
  let getToDate = watch("toDate");
  let getMRNo = watch("mrNo");
  let getSaleReturnNo = watch("saleReturnNo");

  const populateTable = (forPagination) => {
    setShowSpinner(true);
    let obj = {
      fromDate: getFromDate,
      opdIpd: getPatientType,
      storeId: loggedUser?.storeId,
      toDate: getToDate,
      menuId: menuId,
      privilege: privilege,
      returnId: getSaleReturnNo !== "" ? getSaleReturnNo : "",
      mrNo: getMRNo !== "" ? Number(getMRNo) : 0,
      page: !forPagination ? 0 : page,
      size: rowsPerPage,
    };
    getSalesPrevReturnList(obj)
      .then((response) => {
        setShowSpinner(false);
        if (response?.data?.result.length > 0) {
          if (forPagination) {
            setPreviousReturnList((prevData) => [
              ...prevData,
              ...response?.data?.result,
            ]);
          } else {
            setPreviousReturnList(response?.data?.result);
          }
        }
      })
      .catch((error) => {
        setShowSpinner(false);
        errorAlert(error?.message);
      });
  };

  const renderActions = (row, index) => {
    return (
      <div className="flex space-x-2">
        {userActions &&
          userActions?.map((actions) => (
            <div>
              {actions.isAction === true && (
                <>
                  <div className="flex space-x-2 cursor-pointer">
                    {actions.action === "Print" && (
                      <Tooltip title={"Print"}>
                        <LocalPrintshopIcon
                          sx={{ color: "#4B5563" }}
                          onClick={() => {
                            openPrintWindow(row?.SalesReturnId);
                          }}
                        />
                      </Tooltip>
                    )}
                  </div>
                </>
              )}
            </div>
          ))}
      </div>
    );
  };

  useMemo(() => {
    populateTable();
  }, []);

  console.log("userActions321", userActions);

  return (
    <>
      <Modal open={openPrevReturnListModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            p: 2,
            overflow: "scroll",
          }}
          className="space-y-2 w-[90%] h-[80%]"
        >
          <div className="flex justify-between">
            <label className="font-semibold whitespace-nowrap">
              Previous Return List
            </label>
            <CancelPresentationIconButton
              onClick={() => {
                setOpenPrevReturnListModal(false);
              }}
            />
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-7  gap-x-2 gap-y-3">
            <fieldset className="flex gap-1 justify-center items-center bg-white border rounded px-2 -mt-2 lg:col-span-2">
              <legend className="font-semibold text-xs px-2">
                Patient Type
              </legend>
              <div className="-my-2">
                <RadioField
                  className="whitespace-nowrap"
                  control={control}
                  name="patientType"
                  dataArray={patientTypeObj}
                />
              </div>
            </fieldset>
            <div className="flex space-x-2  lg:col-span-2">
              <DatePickerField
                control={control}
                name="fromDate"
                label="From Date"
                disableFuture
                inputFormat="dd/MM/yyyy"
                onChange={(newValue) => {
                  setValue("fromDate", newValue);
                }}
              />
              <DatePickerField
                control={control}
                name="toDate"
                label="To Date"
                disableFuture
                inputFormat="dd/MM/yyyy"
                onChange={(newValue) => {
                  setValue("toDate", newValue);
                }}
              />
            </div>
            <TextField
              control={control}
              name="mrNo"
              {...register("mrNo")}
              size="small"
              label="MRNo"
              type="number"
              onChange={(e) => {
                if (e?.target?.value) {
                  setValue("saleReturnNo", "");
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              control={control}
              name="saleReturnNo"
              {...register("saleReturnNo")}
              size="small"
              label="Sale Return No"
              onChange={(e) => {
                if (e?.target?.value) {
                  setValue("mrNo", "");
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            <div className="flex justify-end col-span-2 xl:col-span-1 lg:justify-start">
              <CommonButton
                type="button"
                searchIcon={true}
                className="bg-customBlue text-white"
                onClick={() => {
                  populateTable(false);
                }}
              />
            </div>
          </div>
          {showSpinner === true ? (
            <div className="flex justify-center items-center h-96">
              <LoadingSpinner />
            </div>
          ) : (
            <div>
              {previousReturnList?.length > 0 ? (
                <CommonDynamicTablePaginationNew
                  dataResult={previousReturnList}
                  page={page}
                  setPage={setPage}
                  rowsPerPage={rowsPerPage}
                  count={count}
                  populateTable={populateTable}
                  renderActions={renderActions}
                  highlightRow={false}
                />
              ) : (
                <div className="font-semibold text-lg h-96 border rounded flex items-center justify-center">
                  No Records Found...
                </div>
              )}
            </div>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default PreviousReturnListModal;
